module.exports = __webpack_public_path__ + "static/media/loader.1a013c68.svg";